import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { useActiveProjectScope } from '@xver/hooks/useActiveProject';
import type { GetMetricsResponse } from '@xver/apis/v1/kufer/containers/model';

export const CONTAINER_METRICS_QUERY_KEY = 'apis.v1.kufer.containers.metrics';

interface UseContainerMetricsQueryParams {
    containerId: string | undefined;
    start?: number;
    end?: number;
    step?: string;
    latest?: boolean;
    metrics?: string;
    refetchInterval?: number | false;
}

export function useContainerMetricsQuery({
    containerId,
    start,
    end,
    step,
    latest,
    metrics,
    refetchInterval = 15000,
}: UseContainerMetricsQueryParams) {
    const { isResolved } = useActiveProjectScope();
    return useQuery<GetMetricsResponse>({
        queryKey: [CONTAINER_METRICS_QUERY_KEY, containerId, start, end, step, latest, metrics],
        queryFn: () =>
            Endpoints.v1.Kufer.Containers.getContainerMetrics(containerId as string, {
                start,
                end,
                step,
                latest,
                metrics,
            }),
        refetchInterval,
        enabled: !!containerId && isResolved,
    });
}
